import React, {Component} from 'react';
import {Row, Col, Card, CardBody} from 'reactstrap';

import BreadCrumb from '../breadcrumbs/CourseHomePageBreadcrumb';
import CourseEditor from './CourseEditorComponent';

import axios from 'axios';
import {serverPath} from "../common";



class CourseEditorPage extends Component
{
	constructor(props)
	{
		super(props);

		this.state =
			{
				courseData:
					{
						name:'',
						shortDescription:''
					},
				tests: [],
				classes:[],
				exams:[]

			}

		this.onFinish = this.onFinish.bind(this);
		this.onNameChange = this.onNameChange.bind(this);
	}

	/*Lifecycle code*/
	componentDidMount()
	{
		getCourseData(this.props.match.params.courseId)
			.then((data)=>
			{
				this.setState(
					{
						...setTests(this.state, data.tests),
						...setClasses(this.state, data.classes),
						...setExams(this.state, data.exams),
						...setCourseData(this.state.courseData,
							{
								...setCourseDataName(this.state.courseData, data.name),
								...setCourseDataShortDescription(this.state.courseData,
									data.descr)
							})
					});
			});

	}



	/*View/handler code*/
	onFinish(data)
	{
		this.props.history.goBack();
		setTimeout(()=>window.location.reload(), 20);
	}

	onNameChange(name)
	{
		this.setState(setCourseData(this.state.courseData,
			setCourseDataName(this.state.courseData, name)));
	}

	/*Render code*/
	render()
	{
		const topics= {classes:this.state.classes, tests:this.state.tests, exams:this.state.exams};

		return (
			<React.Fragment>
				<Row>
					<Col>
						<BreadCrumb courseName={this.state.courseData.name}/>
					</Col>
				</Row>

				<Row className='mt-2'>
					<Col>

						<Card>
							<CardBody>
								<CourseEditor topics= {topics}
											  courseId = {this.props.match.params.courseId}
											  courseData={this.state.courseData}
											  onFinish={this.onFinish}
											  onNameChange={this.onNameChange}
								/>
							</CardBody>
						</Card>
					</Col>
				</Row>

			</React.Fragment>
		);
	}


}

/*Presenter code*/
function setTests(state, tests)
{
	return {tests:tests};
}

function setExams(state, exams)
{
	return {exams:exams};
}

function setClasses(state, classes)
{
	return {classes:classes};
}

function setCourseData(courseData, data)
{
	return {courseData:{...courseData, ...data}};
}

function setCourseDataName(courseData, name)
{
	return {name:name};
}

function setCourseDataShortDescription(courseData, shortDescription)
{
	return {shortDescription:shortDescription};
}

/*Helper code*/
async function getCourseData(courseId)
{
	const response = await axios.get(`${serverPath}/professorService.php`,
		{
			params:
				{
					action:'getCourseData',
					courseId:courseId
				}
		});
	return response.data;
}

export default CourseEditorPage;
